import type { IMessage } from '@carboncopyco/editor-sdk';
import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { useMemo } from 'react';

type SubscribeFunc = (event: MessageEvent) => unknown;

const useSDKCommunicationLayer = (tabId: IGlobalTab['id']) => {
  return useMemo(
    () => ({
      sendMessage: (message: IMessage) => {
        window.dsDesktop.editor.postMessage(message, tabId);
      },
      subscribe: (callback: SubscribeFunc) => {
        window.dsDesktop.editor.onMessage(callback, tabId);

        return () => {
          window.dsDesktop.editor.removeEventListeners(tabId);
        };
      },
    }),
    [tabId]
  );
};

export default useSDKCommunicationLayer;
